import { Box, Button, Typography, useTheme } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { SearchResponseHit } from './SearchResponseHit';
import Cookies from 'universal-cookie';
import { searchResultMap } from './searchResultsMap';
import { tokens } from '../../../global/theme/tokens';
import { useTranslation } from 'react-i18next';

export const SearchResponseGroup = ({ group, onClose, onLoadMore }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const cookies = new Cookies();
  const { t } = useTranslation();

  const prefixLength = cookies.get('searchPrefix').length;

  const type = group.indexUid.substring(prefixLength);

  if (!searchResultMap[type] || group.estimatedTotalHits === 0) return;
  return (
    <Box className="flex flex-col gap-2 rounded-lg">
      <Typography
        className="sticky top-0 backdrop-blur-lg px-3 py-2 rounded-lg"
        variant="h4"
        sx={{ fontWeight: 500 }}
      >
        {t(searchResultMap[type].label)}
      </Typography>
      {group.hits.map((hit) => (
        <SearchResponseHit
          key={hit.id ?? JSON.stringify(hit)}
          hit={hit}
          type={type}
          onClick={onClose}
        />
      ))}
      {onLoadMore && group.estimatedTotalHits > group.hits.length && (
        <Button
          size="small"
          onClick={onLoadMore}
          startIcon={<ExpandMoreIcon />}
          sx={{ alignSelf: 'center', color: colors.grey[500] }}
        >
          {t('Load more')} ({group.hits.length}/{group.estimatedTotalHits})
        </Button>
      )}
    </Box>
  );
};
